<template>
  <div class="img-thank">
    <p class="text-thank-title">¡ BIENVENIDO AL</p>
    <p class="text-thank-title">HAVOLINE MOTOCLUB !</p>
    <div class="message_seccess">
      <p class="text-thank-sub">
        TE HAS REGISTRADO DE MANERA EXITOSA
        <i class="fa fa-check-circle-o icon-thank" aria-hidden="true"></i>
      </p>
    </div>

    <p class="text-thank-sms">¡ {{ message }} !</p>
    <div class="d-flex justify-content-center">
      <button class="btn btn-danger btn-md margin-btn mt-2" @click="irLogin()">
        <strong>Iniciar sesión</strong>
      </button>
    </div>

    <!-- <p class="text-thank-min">
      También puedes registrate con
    </p> -->

    <!-- <button
      :disabled="disableLoading"
      type="button"
      @click="google()"
      class="btn btn-light btn-sm  btn-register"
      id="btn-register-id"
    >
      <span
        v-if="disableLoading"
        class="spinner-border spinner-border-md"
        role="status"
        aria-hidden="true"
      ></span>
      <template v-else>
        <img alt="Google" src="@/assets/icon/google-24px.png" />
        <i> Google </i>
      </template>
    </button> -->
  </div>
</template>

<script>
import { login } from "../../config/auth";
import axios from "axios";
// import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      disableLoading: false,
      message: "Registra tus códigos y redime por grandes premios",
      ip_address: 0
    };
  },
  methods: {
    irLogin(){
      this.$router.push({name: "login"})
    },
    google() {
      this.$gapi.login().then(({ currentUser, hasGrantedScopes }) => {
        var profileU = currentUser.getBasicProfile();
        var data = {
          email: profileU.Et,
          token: currentUser.Zb.id_token,
        };
        axios
          .post("api/login/google", data)
          .then((res) => {
            if (res.data.cod == 0) {
              login(res.data.data.access_token);
              var data1 = {
                email: this.form.email,
                validatePass: res.data.data.ch_pw,
                gender: res.data.data.gender_id,
              };
              sessionStorage.setItem("infoUser", JSON.stringify(data1));
              let encodeUserRole = btoa("userRole");
              let encodeValueUserRole = btoa(res.data.data.roleId);
              sessionStorage.setItem(encodeUserRole, encodeValueUserRole);
              this.redirection(res.data.data.roleId);
              //this.$router.push({name: "profileUser"});
            }
            this.disableLoading = false;
          })
          .catch((error) => {
            console.log(error);
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      });
    },
    getIp(){
      axios
      .get("https://ipinfo.io/json")
      .then((res) => {
        if(res.status == 200){
          this.ip_address = res.data.ip;
          this.sendEvent();
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
    sendEvent(){
      axios
      .post("api/send-data-event", {
        event_name: this.$route.params.event_origin,
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: document.URL,
        action_source: "website",
        user_data: {
          client_ip_address: this.ip_address,
          client_user_agent: window.navigator.userAgent
        }
      })
      .then(() => {
        console.log("Evento enviado correctamente.");
      })
      .catch((err) => {
        console.log("Error enviando el evento:", err);
      });
    },
  },
  destroyed(){
    localStorage.clear();
  },
  created(){
    var sms = localStorage.getItem('sms')
    // console.log(sms)
    if(sms != null){
      this.message = sms;
    }
  },
  mounted(){
    this.getIp();
  }
};
</script>

<style>
.img-thank {
  background-size: cover;
  background-image: url("./../../assets/01.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
  padding-top: 20%;
  padding-bottom: 20%;
}
.text-thank-min {
  font-size: 16px;
  padding-top: 20px;
  font-family: "GothamBookItalic", sans-serif;
}
.text-thank-sms {
  font-size: 20px;
  font-family: "GothamBoldItalic", sans-serif;
}
.text-thank-sub {
  text-align: center;
  width: 52%;
  padding-top: 17px;
  padding-bottom: 5px;
  background-color: #fff;
  color: black;
  font-family: "GothamBoldItalic", sans-serif;
  font-size: 30px;
}
.text-thank-title {
  font-size: 55px !important;
  font-family: "Gotham-UltraItalic", sans-serif;
  margin-bottom: 0px;
}
.icon-thank {
  color: #18d422;
  font-size: 30px;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .img-thank {
    padding-top: 20%;
    padding-bottom: 20%;
  }
  .text-thank-title {
    font-size: 40px !important;
  }
  .text-thank-sub {
    width: 55%;
    padding-top: 15px;
    padding-bottom: 5px;
    font-size: 22px;
  }
   .text-thank-sms {
    font-size: 16px;
  }
    .icon-thank {
    font-size: 23px;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .img-thank {
    padding-top: 35%;
    padding-bottom: 35%;
  }
  .text-thank-title {
    font-size: 40px !important;
  }
  .text-thank-sub {
    width: 65%;
    padding-top: 15px;
    padding-bottom: 5px;
    font-size: 20px;
  }
   .text-thank-sms {
    font-size: 16px;
  }
    .icon-thank {
    font-size: 20px;
  }
}
.message_seccess{
  display: flex; 
  justify-content: center; 
  align-items: center; 
  flex-direction: column;
}

/* MOBILE */
@media (max-width: 767px) {
  .img-thank {
    padding-top: 50%;
    padding-bottom: 50%;
  }
  .text-thank-min {
    font-size: 14px;
    padding-top: 20px;
  }
  .text-thank-sub {
    width: 95%;
    padding-top: 10px;
    padding-bottom: 5px;
    font-size: 16px;
  }
  .text-thank-title {
    font-size: 30px !important;
  }
  .icon-thank {
    font-size: 20px;
  }
  .text-thank-sms {
    font-size: 16px;
  }
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>
